import {DiagnosticReportId, ScoringSystem} from '@legit.health/ui';
import {FormValues} from '@/components/DiagnosticReportForm/components/QuestionnairesForm/interfaces/FormValues';

export default function createDefaultValues({
  scoringSystems,
  companyCallbackUrl,
  diagnosisSupportId
}: {
  scoringSystems: ScoringSystem[];
  companyCallbackUrl: string | null;
  diagnosisSupportId: DiagnosticReportId;
}): FormValues {
  return {
    companyCallbackUrl,
    diagnosticReportId: diagnosisSupportId,
    scoringSystems: scoringSystems.reduce(function (acc, scoringSystem) {
      return {
        ...acc,
        [scoringSystem.id]: scoringSystem.scoringSystemFacets
          .filter((ssf) => ssf.isAskedInQuestionnaire)
          .reduce(
            (acc2, scoringSystemFacet) => ({
              ...acc2,
              [scoringSystemFacet.id]: null
            }),
            {}
          )
      };
    }, {})
  };
}
